(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('events', sellers);

    /* @ngInject */
    function sellers() {
        var directive = {
            bindToController: true,
            templateUrl: 'events.tpl',
            controller: eventsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.eventTypes = scope.vm.data.query[0].customs.eventTypes;
            scope.vm.eventPeriod = 'current';
            scope.vm.eventType = 'all';
            scope.getEvents();
        }

    }

    /* @ngInject */
    function eventsController ($scope, $http) {
        $scope.vm.events = [];

        $scope.getEvents = function() {
            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'get_events',
                nonce: $scope.$root.stats.nonce,
                params: {
                    eventPeriod: $scope.vm.eventPeriod,
                    eventType: $scope.vm.eventType
                }
            }).then(function(response) {
                $scope.vm.events  = response.data.events;
            });
        };
    }

})();